import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInOut, INavbarData } from '../../../shared/helpers/helper';
import { LocalizationService } from 'src/app/shared/localization/localization.service';
import { LocalDataService } from 'src/app/shared/services/local-data.service';
import { Constants } from 'src/app/shared/constants';

@Component({
  selector: 'app-sublevel-menu',
  templateUrl: './sublevel-menu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
  animations: [
    fadeInOut,
    trigger('submenu', [
      state('hidden', style({
        height: '0',
        overflow: 'hidden'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('visible <=> hidden', [style({ overflow: 'hidden' }),
      animate('{{transitionParams}}')]),
      transition('void => *', animate(0))
    ])
  ]
})
export class SublevelMenuComponent implements OnInit {

  @Input() data: INavbarData = {
    link: '',
    icon: '',
    name: '',
    menu: []
  }
  @Input() collapsed = false;
  @Input() animating: boolean | undefined;
  @Input() expanded: boolean | undefined;
  @Input() multiple: boolean = false;

  constructor(
    public router: Router,
    private _localDataService: LocalDataService,
    private _localizationService: LocalizationService
    ) {
      _localizationService.use(this._localDataService.selectedCountry + '_' + this._localDataService.selectedLanguage, Constants.Localization.commonAreas);
    }

  ngOnInit(): void {
  }

  handleClick(item: any): void {
    if (!this.multiple) {
      if (this.data.menu && this.data.menu.length > 0) {
        for (let modelItem of this.data.menu) {
          if (item !== modelItem && modelItem.expanded) {
            modelItem.expanded = false;
          }
        }
      }
    }
    item.expanded = !item.expanded;
  }

  getActiveClass(item: INavbarData): string {
    return item.expanded && this.router.url.includes(item.link)
      ? 'active-sublevel'
      : '';
  }

}
